/**
 * Animation timing constants, delays, and thresholds
 */

export const ROLE_ROTATE_INTERVAL_MS = 3000;

export const SCRAMBLE_FRAME_DELAY_MS = 50;

export const WIDGET_SHOW_DELAY_MS = 2000;

export const CHAT_BLOCK_DURATION_MS = 5 * 60 * 1000;

export const OFF_TOPIC_THRESHOLD = 3;

export const SCROLL_TOP_THRESHOLD = 500;

export const NEWS_NOTIFICATION_SHOW_DELAY_MS = 4000;

export const NEWS_NOTIFICATION_HIDE_DELAY_MS = 24000;

export const NEWS_CACHE_MAX_AGE_MS = 5 * 60 * 1000;

export const NEWS_CACHE_STALE_MS = 2 * 60 * 1000;

export const ARTICLES_PER_PAGE = 10;
